import { render, staticRenderFns } from "./BotConfiguration.vue?vue&type=template&id=1442bf0c&scoped=true&"
import script from "./BotConfiguration.vue?vue&type=script&lang=js&"
export * from "./BotConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./BotConfiguration.vue?vue&type=style&index=0&id=1442bf0c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1442bf0c",
  null
  
)

export default component.exports